// extracted by mini-css-extract-plugin
export default {"review":"review_review__9hkig","profileImg":"review_profileImg__vfJCV","reviewImg":"review_reviewImg__v823Q"};